import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'

import { isDevelopment, isStg } from 'modules/app-config/environment'

import classes from './Header.module.scss'

function getEnvIndicator() {
  if (isDevelopment()) {
    return {
      shellClass: classes.devShell,
      labelClass: classes.envLabelDev,
      label: 'Dev Environment',
    }
  }

  if (isStg()) {
    return {
      shellClass: classes.stgShell,
      labelClass: classes.envLabelStg,
      label: 'Staging Environment',
    }
  }

  return null
}

const ENV_INDICATOR = getEnvIndicator()

const EnvironmentBarContext = createContext({
  isBarColorHidden: false,
  toggleEnvironmentBarColor: () => {},
})

export function EnvironmentBarProvider({ children }) {
  const [isBarColorHidden, setIsBarColorHidden] = useState(false)
  const toggleEnvironmentBarColor = useCallback(() => {
    if (!ENV_INDICATOR) return
    setIsBarColorHidden((current) => !current)
  }, [])
  const value = useMemo(
    () => ({ isBarColorHidden, toggleEnvironmentBarColor }),
    [isBarColorHidden, toggleEnvironmentBarColor]
  )

  return (
    <EnvironmentBarContext.Provider value={value}>
      {children}
    </EnvironmentBarContext.Provider>
  )
}

export function useEnvironmentBar() {
  return useContext(EnvironmentBarContext)
}

export function useShellClassName() {
  const { isBarColorHidden } = useEnvironmentBar()
  if (!ENV_INDICATOR || isBarColorHidden) return classes.shell
  return `${classes.shell} ${ENV_INDICATOR.shellClass}`
}

export function EnvironmentBarLabel() {
  if (!ENV_INDICATOR) return null

  return <div className={ENV_INDICATOR.labelClass}>{ENV_INDICATOR.label}</div>
}
